import type { WorkspaceEntitlements } from "@/packages/domains/billing";
import { useBilling } from "./useBilling";

export function useEntitlements() {
  const { entitlements, tier } = useBilling();

  return {
    canCreateAudit: (currentCount: number) =>
      entitlements.maxAudits === "unlimited" ||
      currentCount < entitlements.maxAudits,
    canInviteMembers: (currentCount: number) =>
      entitlements.maxMembers === "unlimited" ||
      currentCount < entitlements.maxMembers,
    requiresUpgrade: (feature: keyof WorkspaceEntitlements) =>
      typeof entitlements[feature] === "boolean" && !entitlements[feature],
    tier,
  };
}
